<script setup lang="ts">
import { useTeacherStore } from "@/store/teacher";
import { useWindowSize } from "@vueuse/core";
import { useDefaultStore } from "@/store";
import { useSessionStore } from "@/store/session";

defineOptions({
	name: "teacher",
});
definePage({
	name: "teacher",
	path: "/teacher",
	redirect: "/teacher/dashboard",
	meta: {
		roleIds: [1, 3],
	},
});

const store = useDefaultStore();
const teacherStore = useTeacherStore();
const sessionStore = useSessionStore();
const { width } = useWindowSize();
const route = useRoute();
const accountApproved = sessionStore.userData?.accountapproved;

const isCollapsedSidebar = computed(() => {
	return route.name === "teacher.calendar" || width.value <= 1156;
});

watch(
	() => route.fullPath,
	(val) => {
		if (teacherStore.isVisibleTeacherSidebar)
			teacherStore.isVisibleTeacherSidebar = false;
	},
);

onMounted(() => {
	teacherStore.activeStep = store.setActiveStep(
		route.name,
		teacherStore.teacherMenuItems,
	);
});

// const disabledSteps = ref<number[]>([]);

// const setDisabledSteps = () => {
// 	const isApproved = sessionStore.userData?.accountapproved;
// 	if (!isApproved) {
// 		disabledSteps.value = teacherStore.teacherMenuItems
// 			.map((item, index) => (item.heading.requiresValidation ? index : -1))
// 			.filter((i) => i !== -1);
// 	}
// };
</script>

<template>
	<div id="teacher-page">
		<sidebar-comp
			:menu-items="teacherStore.teacherMenuItems"
			:is-collapsed="isCollapsedSidebar"
			:sidebar-active-step="teacherStore.activeStep"
			:account-approved="accountApproved"
			@sidebar-active-step-change="(e) => (teacherStore.activeStep = e)"
			@update:is-collapsed="teacherStore.isVisibleTeacherSidebar = true"
		/>
		<div class="page">
			<teacher-header-bar />
			<router-view></router-view>
		</div>
	</div>
</template>

<style lang="scss" scoped>
#teacher-page {
	min-height: 100vh;
	width: 100%;
	display: flex;
	user-select: none;
	box-sizing: border-box;
	.page {
		flex-grow: 1;
		overflow-x: auto;
	}
	.banner-section {
		flex: 1;
	}
}
</style>
